import apiClient from "./apiClient";
import { ENDPOINTS } from "./endpoints";
import { useQuery } from "@tanstack/react-query";
import queryKeys from "../queryKeys";

export const fetchMaintenances = async (query) => {
    const result = await apiClient.get(`${ENDPOINTS.maintenances}?${query}`);
    return result?.data;
};

export const useFetchMaintenances = ({ query, isEnabled = true, ...options } = {}) => {
    const { data, isFetched, ...rest } = useQuery({
        queryKey: queryKeys.maintenances(query),
        queryFn: () => fetchMaintenances(query),
        enabled: isEnabled,
        refetchOnMount: false,
        ...options,
    });

    return { data, isFetched, ...rest };
};
